const initMemberReward = {
  memberRewards: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
};

export const memberRewardReducer = (state = initMemberReward, action: any) => {
  if (action.type === "SET_MEMBER_REWARD") {
    return {
      ...state,
      memberRewards: action.value,
    };
  }
  if (action.type === "SET_MEMBER_REWARD_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_MEMBER_REWARD_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_MEMBER_REWARD") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  return state;
};
